import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";

export type DeleteCollectionLetterHistoryRequest = {
  id: number;
};

export type DeleteCollectionLetterHistoryResponse = {
  done: boolean;
};

export const deleteCollectionLetterHistory = async (request: DeleteCollectionLetterHistoryRequest) => {
  const response = await executeApiRequest(
    () => axios.delete<DeleteCollectionLetterHistoryResponse>(`/letterhistory/delete`, { params: request, withCredentials: true }),
    false
  );

  return response?.data.done;
};
